<template>
  <div class="location-sublocations">
    <Container
      v-if="sublocationList.length"
      class="location-sublocations__wrapper"
      v-protected
      tag="div"
      lock-axis="y"
      :drop-placeholder="{
        animationDuration: '150',
        showOnTop: true,
      }"
      @drop="handleDrop($event)"
    >
      <Draggable
        v-for="sublocation in sublocationList"
        :key="sublocation.id"
        class="location-sublocations__list"
      >
        <div class="location-sublocations__sublocation">
          <div class="location-sublocations__sublocation_left">
            <ui-icon
              class="mr-2"
              name="stacked-lines"
              size="24"
            />
            <ui-icon-button
              name="qr-code"
              size="24"
              class="location-sublocations__qr-code"
              @click="openQr(sublocation.id)"
            />
            <div
              v-if="sublocation.name"
              class="location-sublocations__name"
              @click="goToSublocation(sublocation.id)"
            >
              <span>{{ sublocation.name }}</span>
              <span
                v-if="sublocation.subLocationType"
                class="location-sublocations__type"
              >
                ({{ $t(`sublocation.types.${sublocation.subLocationType}`) }})
              </span>
            </div>
          </div>
          <div>
            <ui-action-down
              :items="notificationActions"
              @select="handleAction($event, sublocation)"
            />
          </div>
        </div>
      </Draggable>
    </Container>

    <ui-button
      native-type="button"
      outline
      type="primary"
      size="sm"
      class="location-sublocations__add-btn"
      @click="openSublocationModal"
    >
      {{ $t('sublocation.button.add') }}
    </ui-button>

    <location-sublocation-modal
      v-model="showSublocationModal"
      :location="location"
      :title="$t('sublocation.addSublocation')"
      :sublocations="sublocationList"
      :current-sublocation="currentSublocation"
      @closed="clearCurrentSublocation"
    />

    <qr-code
      :show="Boolean(qrIdToShow)"
      :location-id="qrIdToShow"
      @closed="closeQr"
    />
  </div>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd';
import applyDrag from '@/utils/applyDrag';
import LocationSublocationModal from '@/components/Location/LocationSublocationModal.vue';
import QrCode from '@/components/QrCode.vue';

export default {
  name: 'LocationSublocations',
  components: {
    Container,
    Draggable,
    QrCode,
    LocationSublocationModal,
  },

  props: {
    location: {
      type: Object,
      required: true,
    },
    sublocations: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      sublocationList: [],
      showSublocationModal: false,
      currentSublocation: null,
      qrIdToShow: null,
      notificationActions: [
        {
          id: 'edit',
          label: 'Edit',
        },
        {
          id: 'remove',
          label: 'Remove',
        },
      ],
    };
  },

  watch: {
    sublocations: {
      immediate: true,
      handler(value) {
        this.sublocationList = value;
      },
    },
    sublocationList: {
      deep: true,
      handler(value) {
        this.$emit('update:sublocations', value);
      },
    },
  },

  methods: {
    openSublocationModal() {
      this.showSublocationModal = true;
    },
    handleDrop(event) {
      this.sublocationList = applyDrag(this.sublocationList, event, 'showOrder');
    },
    handleAction(event, item) {
      switch (event) {
        case 'edit':
          this.editSublocation(item);
          break;

        case 'remove':
          this.removeSublocation(item);
          break;

        default:
          break;
      }
    },
    editSublocation(item) {
      this.currentSublocation = item;
      this.showSublocationModal = true;
    },
    removeSublocation(item) {
      const removingIndex = this.sublocationList.findIndex((sublocation) => sublocation.id === item.id);
      this.sublocationList.splice(removingIndex, 1);
    },
    clearCurrentSublocation() {
      this.currentSublocation = null;
    },
    goToSublocation(sulocationId) {
      this.$router.push({
        name: 'location-view',
        params: { locationId: sulocationId },
      });
    },
    openQr(sublocationId) {
      this.qrIdToShow = sublocationId;
    },
    closeQr() {
      this.qrIdToShow = null;
    },
  },
};
</script>
